import extractErrorMessage from '../utils/extractErrorMessage';
import { authClient } from './client';

export const fetchCharityDonations = async ({
  orderType = null,
  status = null,
  month = null,
  page = 1,
  limit = 20,
}) => {
  try {
    let query = `?page=${page}&limit=${limit}`;
    if (orderType) query += `&orderType=${orderType}`;
    if (status) query += `&status=${status}`;
    if (month) query += `&month=${month}`;

    const response = await authClient.get(`/admin/charity-donations${query}`);
    return {
      data: {
        items: response.data.data.items,
        page: response.data.data.currentPage,
        totalPages: response.data.data.totalPages,
        totalItems: response.data.data.totalItems,
      },
      error: null,
    };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju humanitarnih donacija.'
    );
    return { data: null, error: message };
  }
};

export const fetchCharityDonationsSummary = async ({ orderType = null }) => {
  try {
    const query = orderType ? `?orderType=${orderType}` : '';
    const response = await authClient.get(
      `/admin/charity-donations/summary${query}`
    );
    return { data: response.data.data, error: null };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri dobavljanju pregleda donacija.'
    );
    return { data: null, error: message };
  }
};

export const updateCharityDonationStatus = async (entryId, status) => {
  try {
    const response = await authClient.patch(
      `/admin/charity-donations/${entryId}/status`,
      { status }
    );
    return { data: response.data.data, error: null };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri izmeni statusa donacije.'
    );
    return { data: null, error: message };
  }
};

export const updateCharityDonationEntriesBulk = async (entryIds, status) => {
  try {
    const response = await authClient.patch(
      '/admin/charity-donations/bulk-status',
      { entryIds, status }
    );
    return { data: response.data.data, error: null };
  } catch (error) {
    const message = extractErrorMessage(
      error,
      'Došlo je do greške pri izmeni statusa donacija.'
    );
    return { data: null, error: message };
  }
};
